import { QuestionTypes } from 'containers/app/helpers/questionTypes';
import { getStoredFile } from 'utils/indexedDBService';

export const getInitialValues = async (
  attemptUUID,
  currentSlotId,
  questionType
) => {
  switch (questionType) {
    case QuestionTypes.UPLOAD:
      // We should be getting the file here if theres one
      const record = await getStoredFile(attemptUUID, currentSlotId);
      if (record) {
        return { [currentSlotId]: record.blob };
      } else {
        return { [currentSlotId]: null };
      }
    case QuestionTypes.BANDED:
      return { [currentSlotId]: null };
    default:
      return { [currentSlotId]: [] };
  }
};
